import { RenderIf } from "../helpers/RenderIf"
import React, { useState } from "react"
import { T, TraksConsumer } from "../traks"
import CreateComment from "./CreateComment"
import { CollapsibleContainer } from "./CollapsibleContainer"
import { PastTimeStamp } from "./TimeComponents"

const Message = ({ message, agent, deleteMessage }) => {
	const mrRight = message.agent === agent
	const alignment = mrRight ? "align-items-start" : "align-items-end"
	let messageClass;
	let content = message.comment
	let Label;
	if (message.action === "added_comment" || message.log_action === "added_comment") {
		messageClass = "font-italic" 
		Label = () => <T>Note by</T>
	} else {
		messageClass = "sibilus_border border_radius_6px p-3 fw_600 bg_light_grey "
		Label = () => <T>Message by</T>
	}

	return (
		<div className={`mb-4 d-flex flex-column ${alignment}`}>
			<div className="d-flex align-items-center">
				<div className={`${messageClass}`}>
					{content}
				</div>
				<RenderIf condition={mrRight}>
					<div className=" btn fs-5 fw_500 cursor_pointer" onClick={() => deleteMessage(message.id)}>
						<img src="https://static.sibilus.eu/gfx/white-trash-0.svg" alt="trash_icon" />
					</div>
				</RenderIf>
			</div>
			<div className="lighter_grey_on_white">
				<Label />{" " + message.agent}
			</div>
			<div className="near_white_grey">
				<PastTimeStamp TimeStampInMs={message.ts} />
			</div>
		</div>
	)
}

const MessageList = ({ whistle, deleteMessage, messages }) => {
	const [numberElements, setNumberElements] = useState(-2)

	const showLoadMoreBtn = messages.length > -(numberElements)
	return (<>
		<RenderIf condition={showLoadMoreBtn}>
			<div className="w-100 py-2 mb-4 text-center fw_600 btn hoverable-grey" onClick={() => setNumberElements(numberElements - 2)}>
				<T>load more</T>
			</div>
		</RenderIf>
		{messages.slice(numberElements).map((message, index) =>
			<div key={"m" + index}>
				<Message
					message={message}
					agent={whistle.access[0].screen_name}
					deleteMessage={deleteMessage}
				/>
			</div>
		)}
	</>)
}

export const Messages = ({ messages, setMessages, whistle, showMessageChoice = false, deleteMessage, className = null }) => {
	return (
		<CollapsibleContainer className={className}>
			<div className="fw_700 fs-5">
				<T>Messages</T>
			</div>
			<div className="px-3 sborder_radius_6px">
				<MessageList
					whistle={whistle}
					deleteMessage={deleteMessage}
					messages={messages}
				/>
				<TraksConsumer>
					<CreateComment
						accessId={whistle.whistle_access_id}
						setMessages={setMessages}
						isItMessage={whistle.access[0].screen_name === "whistle_owner"}
						showMessageChoice={showMessageChoice}
						className="message-input"
						whistle={whistle}
					/>
				</TraksConsumer>
			</div>
		</CollapsibleContainer>
	)
}
